
export class Project {
    public static readonly CodeMaxLength: number = 10;
    public static readonly NameMaxLength: number = 30;

    public id: number = 0;
    public code: string = "";
    public name: string = '';
    public createdOn: Date = new Date();
    public createdBy: string = '';
}

export class ProjectCreateReply {
    public exists: boolean = false;
    public project?: Project = undefined;
}

export class ProjectReply {
    public project?: Project = undefined;
}

export class ProjectMultiReply {
    public projects: Project[] = [];
}
